import React from 'react';
import styled, { css } from 'styled-components';

import OfferLogo from './OfferLogo';

type Props = {
  isDesktop: boolean;
  isMobile: boolean;
  accountName: string;
  logo?: string;
};

const BroughtBySection = ({
  accountName,
  isDesktop,
  isMobile,
  logo,
}: Props) => {
  return (
    <Container $isDesktop={isDesktop}>
      <Text $isMobile={isMobile}>
        Brought to you by {accountName || 'Shido'}
      </Text>
      <OfferLogo accountName={accountName} src={logo} />
    </Container>
  );
};

const Container = styled.section<{ $isDesktop: boolean }>`
  max-width: 1400px;
  padding: 34px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px dashed rgba(65 78 113 / 25%);

  ${({ $isDesktop }) =>
    $isDesktop &&
    css`
      padding: 78px 0;
    `}
`;

const Text = styled.p<{ $isMobile: boolean }>`
  font-size: 20px;
  font-weight: 300;
  line-height: 35px;
  color: ${({ theme }) => theme.colors.topicBlue};
  text-align: center;
  margin-bottom: 34px;

  ${({ $isMobile }) =>
    $isMobile &&
    css`
      font-size: 14px;
      line-height: 20px;
      white-space: pre-line;
      margin-bottom: 0;
      padding: 0 20px;
    `}
`;

export default BroughtBySection;
